import { HeaderFieldCellMixins, FieldCellMixins } from './mixins.js';
import FileMixin from 'trunks/vue/share/components/fields/file.js';

const FileCell = {
  mixins: [FieldCellMixins, FileMixin],

  template: `
    <div class="attachments attachment-thumbnail">
      <div class="attachment-item"
           v-for='attachment in attachments'
           :key='attachment.id'
           :title='attachment.name'
           @click='clickAttachment($event, attachment)'>
        <div class="attachment-preview-container" v-if='canPreview(attachment)'>
          <div class="attachment-content content-centered">
            <img :src="_thumbnailUrl(attachment)" alt="加载失败">
          </div>
        </div>
        <div class="attachment-type" v-else>
          <div class="attachment-content content-centered">
            <file-icon :type='attachment.extension' size='small'/>
          </div>
        </div>
      </div>
    </div>
  `,

  computed: {
    attachments: function() {
      return _.chain(this.entries)
        .pluck('attachment')
        .filter((attachment) => Boolean(attachment))
        .value();
    }
  },

  methods: {
    clickAttachment: function(event, attachment) {
      this.$emit('cellItemClicked', event, attachment);
    }
  }
};

const FileHeaderCell = {
  mixins: [HeaderFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="input-control left-addon">
          <input type="text"
                 class='controlled-input bordered'
                 placeholder='搜索'
                 v-model.trim='keyword'
                 @keyup.enter='updateFilter' />
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
      </div>
    </div>
  `
};

export { FileCell, FileHeaderCell };
